// Crash-safe localStorage JSON access. Two failure modes bite repeatedly
// (SCO-2068 Rankings, SCO-2104 Practice): getItem returns null for a visitor
// who has never stored the key, and JSON.parse throws outright on a corrupt
// value. Keep this module import-free — it is used at module scope during boot,
// before the error boundary exists, so a cycle here would be a white screen.

export function readStoredJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return fallback;
    const parsed = JSON.parse(raw);
    return parsed === null || parsed === undefined ? fallback : parsed;
  } catch (err) {
    console.log(`could not read localStorage "${key}": `, err);
    return fallback;
  }
}

// Writes throw in Safari private mode and storage-blocked webviews
export function writeStoredJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (err) {
    console.log(`could not write localStorage "${key}": `, err);
    return false;
  }
}
